<div class="insurance-request-draft-dialog">

  <p-dialog #draftDialog
            *ngIf="draft != null"
            [modal]="true"
            [baseZIndex]="3000"
            [closable]="true"
            [closeOnEscape]="true"
            appendTo="body"
            styleClass="lifeislife-web-theme product-info-dialog"
            [visible]="true"
            (visibleChange)="onEditingDraftDialogVisibleChange($event)"
  >
    <p-header>
      <span>Demande d'information</span>

      <span class="update-logo" *ngIf="draftUpdating$ | async">
        <i class="fa fa-refresh fa-spin"></i>
      </span>

    </p-header>

    <div class="content">

      <form class="form-table">
        <div class="row">
          <label>Sujet</label>
          <div>
            <input type="text" pInputText
                   name="ticketSubject"
                   [(ngModel)]="draft.subject"
                   (ngModelChange)="syncChanges()"
                   [disabled]="draftCommitting$ | async"
            >
          </div>
        </div>

        <div class="row">
          <label>Message</label>
          <div>
          <textarea pInputTextarea
                    name="ticketMessage"
                    [(ngModel)]="draft.description"
                    (ngModelChange)="syncChanges()"
                    [disabled]="draftCommitting$ | async"
                    cfForceFocus
          >
          </textarea>
          </div>
        </div>

        <div class="row" *ngIf="draft.id != null">
          <label>Pièces jointes</label>
          <div class="ticket-files">
            <app-file-box
              [pagination]="draftFilePaginaition$ | async"
              (paginationChange)="onAttachmentPaginationChange($event)"
              [totalCount]="draftFileCount$ | async"
              [loading]="draftFileLoading$ | async"
              [newFileUploadPath]="draftFileUploadPath$ | async"
              [rows]="draftFiles$ | async"
              [disabled]="draftCommitting$ | async"
              [showFooter]="true"
              [showHeader]="false"
              [downloadOnClick]="false"
              [showUpload]="true"
              [showDelete]="true"
              [showRename]="false"
              (fileClick)="onFileClicked($event)"
              (fileDeleteClick)="onAttachmentRemoveClick($event)"
              (filesUploaded)="onAttachmentsUploaded($event)"
              (uploadAborted)="onAttachmentUploadAborted($event)"
              (uploadErrored)="onAttachmentUploadErrored($event)"
            ></app-file-box>
          </div>
        </div>

        <div *ngIf="draft.id == null">
          Préparation de la demande en cours...
        </div>

        <div class="actions">
          <a class="lifeislife-button-link" (click)="onCommitDraftClick()"
             [class.disabled]="draft.id == null || (draftCommitting$ | async)">
            Envoyer
          </a>
        </div>

        <div class="actions-links" (click)="onDiscardDraftClick()"
        >
          <a>
            Annuler
          </a>
        </div>

      </form>
    </div>

  </p-dialog>


  <file-download></file-download>
</div>
